import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APIRequestResources, PaginationResponse } from 'src/app/core';
import { CachedAPIRequest } from 'src/app/core/classes/cached.api.request.class';
import { CreateUserDTO, ResourceGetByUser, UserDTO, UserFindDTO, saveResourcesDTO, saveUserApplicationDTO } from '../interfaces/user.entity';
import { LoadingService } from 'src/app/core/components/loading/loading.service';
import { BehaviorSubject, finalize, Subject, take, tap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class UserService extends CachedAPIRequest{

    loading = inject(LoadingService);
    private refreshTrigger = new Subject<void>();

    $all = new BehaviorSubject<UserFindDTO[]>([]);
    all = toSignal(this.$all, {initialValue: []});

    
    $active = new BehaviorSubject<any | undefined>(undefined);
    active = toSignal(this.$active, {initialValue: undefined});

    private readonly $statistics = new BehaviorSubject<any>(undefined)
      stat = toSignal(this.$statistics, {initialValue: undefined})

  constructor(protected override http: HttpClient, private router: Router) {
      super(http, APIRequestResources.UserService)
    }

    create = (createUserDTO: CreateUserDTO) => {
        return this.post<any>(createUserDTO,{}).pipe(
        )
      }

    find = (searchParams: any, refresh = true) => {
        return this.get<PaginationResponse<UserFindDTO[]>>(
          {endpoint: `find`, params: searchParams} , refresh ? 'freshness' : 'performance')
          .pipe(
            tap((res) => {
              if (res.data?.data) {
                this.$all.next(res.data.data);
              }
            }))
      }

      getById = (id: string, refresh = true) => {
        return this.get<UserDTO>({id}, refresh ? 'freshness' : 'performance')
            .pipe(tap((res) => this.$active.next(res.data)),);
    }

    resourceGetByUser = (userId: number, applicationId: number, refresh = true) => {
        return this.get<ResourceGetByUser>({endpoint: `resource`,params: {userId: userId, applicationId: applicationId}}, refresh ? 'freshness' : 'performance')
          .pipe(tap((res) => this.$active.next(res.data)),)
    }

    saveUserApplication = (saveUserApplicationDTO: saveUserApplicationDTO) => {
      return this.post<any>(saveUserApplicationDTO,{endpoint: `applications`}).pipe(
      )
    }

    saveResources = (saveResourcesDTO : saveResourcesDTO) => {
      return this.post<any>(saveResourcesDTO, {endpoint: `resource`}).pipe(

      )
    }

    updatePassword = (userId: number, password: string) => {
      return this.patch<any>({}, { id: String(userId), params: { password } }).pipe();
    }

}